<template>
  <div class="container form">
  <form action="https://formspree.io/f/mjvjqbeg" method="post">

    <label for="fname">First Name</label>
    <input type="text" id="fname" name="firstname" placeholder="Your name..">

    <label for="lname">Last Name</label>
    <input type="text" id="lname" name="lastname" placeholder="Your last name..">

    <label for="country">Country</label>
    <select id="country" name="country">
      <option value="australia">Australia</option>
      <option value="canada">Canada</option>
      <option value="usa">USA</option>
      <option value="australia">Italy</option>
      <option value="canada">Spain</option>
      <option value="usa">Portugal</option>
      <option value="australia">Nigeria</option>
      <option value="canada">Egypt</option>
      <option value="usa">Zimbabwe</option>
      <option value="australia">England</option>
      <option value="canada">New Zealand</option>
      <option value="usa">Namibia</option>
    </select>

    <label for="subject">Subject</label>
    <textarea id="subject" name="subject" placeholder="Write something.." style="height:200px"></textarea>

    <input type="submit" value="Submit">

  </form>
</div>
</template>

<script>
export default {

}
</script>

<style scoped>

input[type=text], select, textarea {
  width: 100%; 
  padding: 12px;  
  border: 1px solid #ccc; 
  border-radius: 4px; 
  box-sizing: border-box; 
  margin-top: 6px; 
  margin-bottom: 16px; 
  resize: vertical 
}


input[type=submit] {
  background-color: #5289ee;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* When moving the mouse over the submit button, add a darker green color */
input[type=submit]:hover {
  background-color: #45a049;
}

/* Add a background color and some padding around the form */
.form{
  border-radius: 5px;
  background-color: #cfeaf1;
  padding: 20px;
}

</style>